import Vue from "vue"
import moment from "moment"

Vue.filter("date", function (value) {
  if (!value) return ""
  return moment(value).format("D MMM, YYYY", "id")
})

Vue.prototype.$timezones = (value) => {
  let zone = moment(value).utcOffset()
  let curr = moment(value).utcOffset(zone).format()

  return curr
}

Vue.prototype.$callbackdate = (value) => {
  if (!value) return ''
  return moment(value).format('YYYY-MM-DD', 'id')
}

Vue.prototype.$callbacktime = (value) => {
  if (!value) return ''
  return moment(value).format('HH:mm', 'id')
}

Vue.filter("time", function (value) {
  if (!value) return ""
  return moment(value).format("HH:mm", "id")
})

Vue.filter("datetime", function (value) {
  if (!value) return ""
  return moment(value).format("D MMM, YYYY HH:mm", "id")
})

Vue.filter("day", function (value) {
  if (!value) return ""
  return moment(value).format("DD", "id")
})

Vue.filter("month", function (value) {
  if (!value) return ""
  return moment(value).format("MMM", "id")
})

Vue.filter("year", function (value) {
  if (!value) return ""
  return moment(value).format("YYYY", "id")
})

Vue.filter("millis", function (value) {
  let sec = Math.floor(value / 1000)
  let hrs = Math.floor(sec / 3600)
  sec -= hrs * 3600
  let min = Math.floor(sec / 60)
  sec -= min * 60

  sec = "" + sec
  sec = ("00" + sec).substring(sec.length)
  if (hrs > 0) {
    min = "" + min
    min = ("00" + min).substring(min.length)
    if (min > 0 && sec > 0) {
      return hrs + " jam " + min + " menit " + sec + " detik "
    } else if (min > 0 && sec < 1) {
      return hrs + " jam " + min + " menit "
    } else if (min < 1 && sec < 1) {
      return hrs + " jam "
    }
  } else if (min > 0) {
    if (sec > 0) {
      return min + " menit " + sec + " detik "
    } else {
      return min + " menit "
    }
  } else {
    return sec + " detik "
  }
})

Vue.filter("price", (num) => {
  if (isNaN(num)) return "Not a Number"
  let price = ""
  const reverseNumber = num
    .toString()
    .split("")
    .reverse()
    .join("")
  const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  arrReverseNumber.map(index => {
    if (index % 3 === 0) price += reverseNumber.substr(index, 3) + "."
  })

  return `Rp ${
    price.split("", price.length - 1)
    .reverse()
    .join("")
  }`
})

Vue.filter("phone", function (value) {
  if (!value) return ""
  return value.substring(0, 4) + " - XXXX - XXXX"
})

// Vue.filter("html", function (value) {
//   if (!value) return ""
//   let a = value.replace(/&lt;/g, '<')
//   // return value.replace(/<[^>]+>/g, '')
//   var stripedHtml = a.replace(/<[^>]+>/g, '');
//   var decodedStripedHtml = he.decode(stripedHtml);
//   return a.replace(/<(?:.|\n)*?>/gm, '')
// })

Vue.filter("email", function (value) {
  if (!value) return ""
  return value.substring(0, 5) + "@XXXXX"
})

Vue.filter("address", function (value) {
  if (!value) return ""
  return value.substring(0, 10) + " . . ."
})

export default {
  moment
}